import MobileMessagesUtils from '@/utils/mobileMessagesUtils.js';
import { externalLinkRedirect } from '@/router';
import loginAsSession from '@/utils/login-as-session';
import { client, clientWithoutErrorHandling } from '../http';

export default {
  async generateCode({ phoneNumber, force, sendPlatform }) {
    return await client.post('/api/no-auth/login/generate-code', { phoneNumber, force, sendPlatform });
  },
  // Every code login (login, signup, member invite) is the customer's own: it ends a login-as
  // session in this tab. Only on success, so a failed code leaves the mark.
  async authenticate({ phoneNumber, code }) {
    const response = await client.post('/api/no-auth/login/authenticate', { phoneNumber, code });
    loginAsSession.clearIncognito();
    return response;
  },
  async isLoggedIn() {
    const response = await clientWithoutErrorHandling.get('/api/logged-in/', {
      validateStatus: status => status === 200 || status === 403,
    });
    return response.status === 200;
  },
  async isOtsIlLoggedIn() {
    const response = await clientWithoutErrorHandling.get('/api/ots-il/logged-in/', {
      validateStatus: status => status === 200 || status === 403,
    });
    return response.status === 200;
  },
  async isPartialLoggedIn() {
    const response = await clientWithoutErrorHandling.get('/api/partial-auth/logged-in/', {
      validateStatus: status => status === 200 || status === 403,
    });
    return response.status === 200;
  },
  async is2faRequired() {
    const response = await client.get('/api/partial-auth/is2faRequired');
    return response.data.required;
  },
  async loginAs({ customerToken }) {
    return await client.post('/api/no-auth/login-as', { customerToken });
  },
  async logout() {
    await client.get('/api/logout');
    externalLinkRedirect('/api/no-auth/logout');
    MobileMessagesUtils.dispatchMessageToMobile(MobileMessagesUtils.MOBILE_MESSAGES_NAME.LOGOUT, {});
  },
  async logCookies() {
    return await client.get('/api/log-cookies');
  },
  async removeToken() {
    return await client.get('/api/no-auth/remove-cookie');
  },
  async sendReFinanceLink(phoneNumber, anonId) {
    return await client.post('/api/no-auth/send-sms', {
      phoneNumber,
      source: 'refinance',
      anonId,
    });
  },
};
